interface SpinnerProps {
  size?: number;
  className?: string;
}

/** Custom loading spinner — replaces antd Spin. */
export default function Spinner({ size = 24, className = '' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={['inline-block animate-spin rounded-full border-2 border-brand/25 border-t-brand', className].join(' ')}
      style={{ width: size, height: size }}
    />
  );
}
